module.exports = __webpack_public_path__ + "img/IMG_6726_L_Black_MockedUp.232e94c6.jpg";